var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.id == 3)?_c('monthlysocso-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 9)?_c('monthlysocsohlb-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 14)?_c('monthlysocsoambank-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 21)?_c('monthlysocsocimb-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 34)?_c('monthlysocsoaffin-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 28)?_c('monthlysocsopublic-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 40)?_c('monthlysocsohsbc-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.id == 47)?_c('monthlysocsoalliance-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(this.item && this.item.expfmtcode == 'Maybank-SOCSO')?_c('monthlysocsomaybank-form',{attrs:{"parentObject":{
            data: this.item,
            id: this.id,
            errMsg: this.errMsg,
        }}}):_vm._e(),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
                data: this.errMsg,
                isErr: this.isErr
            }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }